import { httpApi } from '@app/api/http.api';
import {
  News,
  CreateNewsDto,
  UpdateNewsDto,
  NewsPaginatedResponse,
  NewsFilters,
} from '@app/types/api.types';

export const createNews = (data: CreateNewsDto): Promise<News> =>
  httpApi.post<News>('/news', data).then(({ data }) => data);

export const getNews = (filters?: NewsFilters): Promise<NewsPaginatedResponse> =>
  httpApi
    .get<NewsPaginatedResponse>('/news', { params: filters })
    .then(({ data }) => data);

export const getPublishedNews = (params?: { page?: number; limit?: number }): Promise<NewsPaginatedResponse> =>
  httpApi
    .get<NewsPaginatedResponse>('/news/published', { params })
    .then(({ data }) => data);

export const getNewsById = (id: string): Promise<News> =>
  httpApi.get<News>(`/news/${id}`).then(({ data }) => data);

export const updateNews = (id: string, data: UpdateNewsDto): Promise<News> =>
  httpApi.patch<News>(`/news/${id}`, data).then(({ data }) => data);

export const deleteNews = (id: string): Promise<void> =>
  httpApi.delete<void>(`/news/${id}`).then(() => undefined);
